/**
 * © [2020] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ALL_PLANS = 'GET_ALL_PLANS';
export const GET_ALL_PLAN_BY_REBATE_PROGRAM_CODE =
  'GET_ALL_PLAN_BY_REBATE_PROGRAM_CODE';
export const OPEN_COMMENTS = 'OPEN_COMMENTS';
export const GET_PLANS_BY_CGP = 'GET_PLANS_BY_CGP';
export const GET_ALL_CLIENTS_FOR_PLAN = 'GET_ALL_CLIENTS_FOR_PLAN';
export const GET_ALL_CLIENTS_FOR_PROVIDER = 'GET_ALL_CLIENTS_FOR_PROVIDER';

export const GET_ALL_GROUPS_FOR_CLIENT_DROPDOWN =
  'GET_ALL_GROUPS_FOR_CLIENT_DROPDOWN';
export const GET_REBATE_PROGRAM_CODE_FROM_CGP =
  'GET_REBATE_PROGRAM_CODE_FROM_CGP';
export const SAVE_OR_UPDATE = 'SAVE_OR_UPDATE';
export const GET_CONTACT_TYPE_CLIENT = 'GET_CONTACT_TYPE_CLIENT';
export const GET_CONTACT_TYPE_GROUP = 'GET_CONTACT_TYPE_GROUP';
export const GET_CONTACT_TYPE_PLAN = 'GET_CONTACT_TYPE_PLAN';
export const GET_CONTACT_TYPE_PROVIDER = 'GET_CONTACT_TYPE_PROVIDER';

export const GET_EXISTING_CONTACT_DETAILS_CLIENT =
  'GET_EXISTING_CONTACT_DETAILS_CLIENT';
export const GET_EXISTING_CONTACT_DETAILS_GROUP =
  'GET_EXISTING_CONTACT_DETAILS_GROUP';
export const GET_EXISTING_CONTACT_DETAILS_PLAN =
  'GET_EXISTING_CONTACT_DETAILS_PLAN';
export const GET_EXISTING_CONTACT_DETAILS_PROVIDER =
  'GET_EXISTING_CONTACT_DETAILS_PROVIDER';
export const GET_CONTACT_DETAILS_CLIENT = 'GET_CONTACT_DETAILS_CLIENT';
export const GET_CONTACT_DETAILS_GROUP = 'GET_CONTACT_DETAILS_GROUP';
export const GET_CONTACT_DETAILS_PLAN = 'GET_CONTACT_DETAILS_PLAN';
export const GET_CONTACT_DETAILS_PROVIDER = 'GET_CONTACT_DETAILS_PROVIDER';

export const UPDATE_CONTACT_DETAILS = 'UPDATE_CONTACT_DETAILS';
export const DELETE_PLAN_DETAILS = 'DELETE_PLAN_DETAILS';
export const DELETE_PLAN_HANDLE_FROM_GRID_COMPONENT =
  'DELETE_PLAN_HANDLE_FROM_GRID_COMPONENT';
export const UPDATE_PLAN_WHEN_USER_UPDATE = 'UPDATE_PLAN_WHEN_USER_UPDATE';
export const ADD_NEW_DATE = 'ADD_NEW_DATE';
export const CREATE_NEW_PLAN = 'CREATE_NEW_PLAN';
export const SET_PLAN_SEARCH_VALUES = 'SET_PLAN_SEARCH_VALUES';
export const SOFT_DELETE_DATA = 'SOFT_DELETE_DATA';
export const PLAN_DATA_ACTION_TYPES = 'PLAN_DATA_ACTION_TYPES';
export const UPDATE_DATES_ROWS = 'UPDATE_DATES_ROWS';
export const CONTACT_FORM_VALIDITY = 'CONTACT_FORM_VALIDITY';
export const SAVE_CONTACT_DATA = 'SAVE_CONTACT_DATA';
export const RESET_CONTACT_DATA = 'RESET_CONTACT_DATA';
export const PLAN_TAB_DATA = 'PLAN_TAB_DATA';
export const CLEAR_REDUX_DATA = 'CLEAR_REDUX_DATA';
export const REDUX_STORE_DATA_SEARCH_SER = 'REDUX_STORE_DATA_SEARCH_SER';
